import React from 'react'

import {
  Card,
  CardContent,
  Grid,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material'

const VirtuesRecord = (props) => {
  return (
    <Card sx={{ borderRadius: 2, p: 2 }}>
      <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography color='primary' variant='body1'>
              <b style={{ fontWeight: 900 }}>MAPA DE VIRTUDES</b>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <List disablePadding>
              <ListItem sx={{ p: 0 }}>
                <ListItemText primary={<b>Tres virtudes destacadas</b>} secondary='Sin definir' />
              </ListItem>
              <ListItem sx={{ p: 0 }}>
                <ListItemText primary={<b>Tres incapacidades</b>} secondary='Sin definir' />
              </ListItem>
              <ListItem sx={{ p: 0 }}>
                <ListItemText primary={<b>Tres virtudes propuestas por preceptor</b>} secondary='Sin definir' />
              </ListItem>
              <ListItem sx={{ p: 0 }}>
                <ListItemText primary={<b>Tres virtudes propuestas por padres</b>} secondary='Sin definir' />
              </ListItem>
            </List>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default VirtuesRecord